import React from "react";

const Blog = () => {
  return (
    <div className="flex justify-center items-center h-[100vh]">
      <h1 className="lg:text-2xl font-bold text-center text-primary uppercase">
        Blog will coming soon...
      </h1>
    </div>
  );
};

export default Blog;
